var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<input type="text" name="tbf2-search" class="js-search" placeholder="Search (&quot;Enter&quot; to submit)"/>\n';
}
return __p;
};
